const constants = require('@/util/constants')
require('./config')

/**
 * 登录OAuth2
 * @param {*} username 用户名
 * @param {*} password 密码
 */
export function login(username, password, successcb, failedcb) {
    axios({
        method: 'post',
        url: '/oauth/token',
        params: {
            'username': username,
            'password': password,
            'grant_type': 'password',
            'scope': 'all'
        },
        auth: {
            username: 'client',
            password: 'secret'
        }
    }).then(function (response) {
        successcb(response.data)
    }).catch(function (error) {
        failedcb(error)
    })
}

/**
 * 验证码登录
 * @param {*} mobile 手机号
 * @param {*} code 验证码
 */
export function smsLogin(mobile, code, successcb, failedcb) {
    axios({
        method: 'post',
        url: '/mobile/token',
        params: {
            "mobile": mobile,
            "code": code,
            "grant_type": "mobile",
            "scope": "all"
        },
        auth: {
            username: 'client',
            password: 'secret'
        }
    }).then(function (response) {
        successcb(response.data)
    }).catch(function (error) {
        failedcb(error)
    })
}

/**
 * 发送手机验证码
 * 
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function sendSmsCode(mobile, successcb, failedcb) {
    axios.get('/sms/api/send', {
        params: {
            'mobile': mobile,
            'client': constants.HTTP_CLIENT
        }
    }).then(response => {
        successcb(response.data)
    }).catch(error => {
        failedcb(error)
    })
}
